'use client';

import { useEffect, useRef } from 'react';
import { animate } from 'framer-motion';
import { Text, TextProps } from '@chakra-ui/react';

interface Props extends TextProps {
  value: number;
  formatValue?(value: number): string;
  onCountEnd?(): void;
}

export type AnimatedCounterProps = Props;

export const AnimatedCounter = (props: Props) => {
  const { value, formatValue, onCountEnd, ...rest } = props;

  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const controls = animate(0, value, {
      duration: 2,
      onComplete: onCountEnd,
      onUpdate(latest) {
        if (!ref.current) return;

        ref.current.textContent = formatValue?.(latest) || latest.toFixed(0);
      },
    });

    return () => {
      controls.stop();
    };
  }, [value]);

  return <Text as="span" ref={ref} {...rest} />;
};
